import { DropDownItem } from '@hulu/react-style-components';
import styled from 'styled-components';

/**
 * Useful as a wrapper for Trek dropdown in conjunction with IconTooltip label.
 * Necessary workaround to apply global CSS overrides to default Trek dropdown styling so that it accomodates Icontooltip label.
 */
export const DropdownTooltipWrapper = styled.div`
  .TrekDropDown-popUpContainer {
    z-index: 1400;
  }

  .TrekDropDown-root {
    overflow: visible;

    label {
      height: auto;
    }

    .TrekDropDown-label {
      margin-bottom: ${({ theme }): string => theme.spacers!.spacer01};
      height: auto;
    }
  }
`;

export const Wrapper = styled.div`
  .TrekDropDown-root {
    button {
      svg:nth-child(2) {
        visibility: hidden;
      }
    }
  }
`;

export const DropDownItemButton = styled(DropDownItem)`
  padding: ${({ theme }): string => theme.spacers!.spacer04};
  color: ${({ theme }): string => theme.admanColors!.blue.solid};
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;

  &:hover {
    color: ${({ theme }): string => theme.admanColors!.blue.solid};
  }
`;
